import { IconProps } from "interfaces/icons";

const DollarIcon = ({ size, color }: IconProps): JSX.Element => {
	let height = 24;

	if (size) {
		height = size;
	}

	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			enableBackground="new 0 0 24 24"
			width={height}
			height={height}
			viewBox="0 0 24 24"
			fill="none"
			stroke={color || "#0A0E27"}
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<line x1="12" y1="1" x2="12" y2="23" />
			<path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
		</svg>
	);
};

export default DollarIcon;
